if(!customElements.get('pagination-button')){
    class ProductListPaginationButton extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.btnLoadMore = this.querySelector('.btn-load-more');

            if(this.closest('custom-search-product-list')){

                this.productList = this.closest('custom-search-product-list');
                this.productsWrapper = this.productList.querySelector('#search-item-list__items-wrapper');
                this.products = this.productList.querySelector('#search-item-list__items');
                this.content = 'search';

            }else if(this.closest('custom-collection-product-list')){

                this.productList = this.closest('custom-collection-product-list');
                this.productsWrapper = this.productList.querySelector('#collection-product-list__products-wrapper');
                this.products = this.productList.querySelector('#collection-product-list__products');
                this.content = 'collection';

            }
            
            this.btnColumnSwitch = this.productList.querySelector('.product-view-switch-wrapper');

            this.btnLoadMore.addEventListener('click', e => {
                e.preventDefault();

                this.btnLoadMore.setAttribute('data-disabled', 'true');
                this.loadMoreProducts();
            });

            this.btnLoadMore.addEventListener('keydown', e => {
                if(e.key === 'Enter'){
                    e.preventDefault();

                    this.btnLoadMore.setAttribute('data-disabled', 'true');
                    this.loadMoreProducts();
                }
            })

            this.updateRowFill();

            this.onResize = () => {
                clearTimeout(this.resizeTimer);
                this.resizeTimer = setTimeout(() => this.updateRowFill(), 150);
            };
            window.addEventListener('resize', this.onResize);

            if(this.btnColumnSwitch){
                this.onColumnSwitch = () => setTimeout(() => this.updateRowFill(), 0);
                this.btnColumnSwitch.addEventListener('click', this.onColumnSwitch);
                this.btnColumnSwitch.addEventListener('keydown', e => {
                    if(e.key === 'Enter') this.onColumnSwitch();
                });
            }
        }

        disconnectedCallback(){
            window.removeEventListener('resize', this.onResize);
            clearTimeout(this.resizeTimer);
        }

        getCards(){
            return [...this.products.querySelectorAll('.product-card__wrapper, .article-card__wrapper, .page-card__wrapper')];
        }

        // Hide the trailing cards that don't fill a complete row at the current
        // column count, so the grid always ends on a full row while more items
        // remain to load. Hidden cards reappear with the next "load more" batch;
        // once everything is loaded, all cards show (a partial last row then
        // means the true end of the list).
        updateRowFill(){
            const cards = this.getCards();
            if(cards.length === 0) return;

            cards.forEach(card => {
                if(card.dataset.rowFillHidden){
                    card.classList.remove('d-none');
                    delete card.dataset.rowFillHidden;
                }
            });

            if(!this.btnLoadMore || this.btnLoadMore.classList.contains('d-none')) return;

            // cards per row = how many share the first card's top offset
            const firstTop = cards[0].offsetTop;
            let perRow = 0;
            for(const card of cards){
                if(Math.abs(card.offsetTop - firstTop) < 2) perRow++;
                else break;
            }
            if(perRow < 2) return;

            const remainder = cards.length % perRow;
            if(remainder === 0) return;

            cards.slice(-remainder).forEach(card => {
                card.classList.add('d-none');
                card.dataset.rowFillHidden = 'true';
            });
        }

        async loadMoreProducts(){
            try{
                const nextPageRes = await fetch(
                    `${this.btnLoadMore.dataset.url}`
                );
                const nextPageText = await nextPageRes.text();
                const nextPageHTML = new DOMParser().parseFromString(nextPageText, 'text/html');

                const productsWrapper = this.content == 'collection'? 
                    nextPageHTML.querySelector('#collection-product-list__products-wrapper'):
                    nextPageHTML.querySelector('#search-item-list__items-wrapper');

                const products = this.content == 'collection'? 
                    productsWrapper.querySelector('#collection-product-list__products'):
                    productsWrapper.querySelector('#search-item-list__items');

                const btnLoadMore = productsWrapper.querySelector('.btn-load-more');

                // get product 
                const productCards = products.querySelectorAll('.product-card__wrapper, .article-card__wrapper, .page-card__wrapper');
                
                productCards.forEach(item => {
                    if(this.btnColumnSwitch.dataset.column == '3'){
                        item.classList.add('col-xl-3');
                        item.classList.add('col-6');
                        item.classList.remove('col-xl-4');
                        item.classList.remove('col-12');
                    }else{
                        item.classList.add('col-xl-4');
                        item.classList.add('col-12');
                        item.classList.remove('col-xl-3');
                        item.classList.remove('col-6');
                    }

                    this.products.appendChild(item);
                });

                if(btnLoadMore){
                    this.btnLoadMore.classList.remove('d-none');
                    this.btnLoadMore.setAttribute('data-url', `${btnLoadMore.dataset.url}`);
                }else{
                    this.btnLoadMore.classList.add('d-none');
                }

                this.updateRowFill();

                if (productCards.length > 0) {
                    setTimeout(() => {
                        const focusCard = [...productCards].find(card => !card.classList.contains('d-none')) || productCards[0];
                        if(focusCard.querySelectorAll('.tab-able-item').length > 0){
                            focusCard.querySelectorAll('.tab-able-item')[0].focus();
                        }
                    }, 100);
                }

                // add swatch checked
                const variantSwatchSelector = this.products.querySelectorAll('variant-swatch-selector');
                if(variantSwatchSelector.length > 0){
                    variantSwatchSelector.forEach(item => {
                        item.loadCheckedRadioInput();
                    });
                }
            } catch (error){

                console.error(error);
                alert(error.message);

            } finally {
                this.btnLoadMore.setAttribute('data-disabled', 'false');
            }
        }
    }

    customElements.define('pagination-button', ProductListPaginationButton);
}
